import { API, APIError } from ".";
import type { OpenAPI } from "../../interfaces";

export const calendars = (api: API) => ({
  getAll(
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/calendars/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/calendars/${forType}/${forId}`,
      null,
      success,
      fail,
    );
  },
  create(
    forType: string,
    forId: string,
    data: OpenAPI.POST<"/calendars/{for_type}/{for_id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{for_type}/{for_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${forType}/${forId}`,
      data,
      success,
      fail,
    );
  },
  get(
    calendarId: string,
    success: (
      data: OpenAPI.GET<"/calendars/{calendar_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/calendars/${calendarId}`,
      null,
      success,
      fail,
    );
  },
  update(
    calendarId: string,
    data: OpenAPI.PUT<"/calendars/{calendar_id}">["requestBody"],
    success: (
      data: OpenAPI.PUT<"/calendars/{calendar_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/calendars/${calendarId}`,
      data,
      success,
      fail,
    );
  },
  delete(
    calendarId: string,
    success: (
      data: OpenAPI.DELETE<"/calendars/{calendar_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/calendars/${calendarId}`,
      null,
      success,
      fail,
    );
  },
  getCalendar(
    calendarId: string,
    success: (
      data: OpenAPI.GET<"/calendars/{calendar_id}/calendar">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/calendars/${calendarId}/calendar`,
      null,
      success,
      fail,
    );
  },
  updateCalendar(
    calendarId: string,
    data: OpenAPI.POST<"/calendars/{calendar_id}/calendar">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar`,
      data,
      success,
      fail,
    );
  },
  getCalendarNotificationRecipientCount(
    calendarId: string,
    success: (
      data: OpenAPI.GET<"/calendars/{calendar_id}/calendar/notification-recipients/count">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/calendars/${calendarId}/calendar/notification-recipients/count`,
      null,
      success,
      fail,
    );
  },
  createCalendarEvent(
    calendarId: string,
    event: OpenAPI.POST<"/calendars/{calendar_id}/calendar/events">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/events">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar/events`,
      event,
      success,
      fail,
    );
  },
  updateCalendarEvent(
    calendarId: string,
    eventId: string,
    event: OpenAPI.POST<"/calendars/{calendar_id}/calendar/events/{event_id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/events/{event_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar/events/${eventId}`,
      event,
      success,
      fail,
    );
  },
  deleteCalendarEvent(
    calendarId: string,
    eventId: string,
    success: (
      data: OpenAPI.DELETE<"/calendars/{calendar_id}/calendar/events/{event_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/calendars/${calendarId}/calendar/events/${eventId}`,
      null,
      success,
      fail,
    );
  },
  leaveCalendarEvent(
    calendarId: string,
    eventId: string,
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/events/{event_id}/leave">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar/events/${eventId}/leave`,
      null,
      success,
      fail,
    );
  },
  getCalendarSyncUrl(
    calendarId: string,
    success: (
      data: OpenAPI.GET<"/calendars/{calendar_id}/calendar/sync">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/calendars/${calendarId}/calendar/sync`,
      null,
      success,
      fail,
    );
  },
  shiftCalendarEvents(
    calendarId: string,
    data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/shift">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/shift">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar/shift`,
      data,
      success,
      fail,
    );
  },
  importCalendar(
    toCalendarId: string,
    fromCalendarId: string,
    data: OpenAPI.POST<"/calendars/{to_calendar_id}/calendar/import/{from_calendar_id}">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{to_calendar_id}/calendar/import/{from_calendar_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${toCalendarId}/calendar/import/${fromCalendarId}`,
      data,
      success,
      fail,
    );
  },
  generatePlan(
    calendarId: string,
    data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/plans">["requestBody"],
    success: (
      data: OpenAPI.POST<"/calendars/{calendar_id}/calendar/plans">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/calendars/${calendarId}/calendar/plans`,
      data,
      success,
      fail,
    );
  },
  deletePlan(
    calendarId: string,
    planId: string,
    success: (
      data: OpenAPI.DELETE<"/calendars/{calendar_id}/calendar/plans/{plan_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/calendars/${calendarId}/calendar/plans/${planId}`,
      null,
      success,
      fail,
    );
  },
});
